module.exports = __webpack_public_path__ + "img/3.3ba5ff36.jpg";